module.exports = __webpack_public_path__ + "static/logo-icon-80ab59a1bdc6836d31298b2011fbd49c.png";